module.exports = __webpack_public_path__ + "static/media/54.4392622e.jpg";